import { Card, CardTitle, Toggle } from '@/ui/primitives';
import type { User } from '@/lib/auth';
import { useUpdatePreferences } from '../api';

interface Props {
  user: User;
}

const ITEMS = [
  {
    key: 'notif_sla' as const,
    label: 'Alertas de SLA',
    desc: 'Notificar quando processos se aproximarem do prazo.',
  },
  {
    key: 'notif_documentos' as const,
    label: 'Documentos pendentes',
    desc: 'Avisar quando faltar documentação em clientes ativos.',
  },
  {
    key: 'notif_atribuidos' as const,
    label: 'Itens atribuídos a mim',
    desc: 'Notificar quando uma tarefa ou processo for atribuído.',
  },
];

export function PreferenciasNotificacao({ user }: Props) {
  const update = useUpdatePreferences(user.id, user);
  const prefs = (user.preferences ?? {}) as Record<string, unknown>;

  function toggle(key: 'notif_sla' | 'notif_documentos' | 'notif_atribuidos', next: boolean) {
    update.mutate({ [key]: next });
  }

  return (
    <Card padding="lg">
      <CardTitle>Preferências de notificação</CardTitle>
      <ul className="flex flex-col divide-y divide-border mt-3">
        {ITEMS.map((item) => {
          const checked = prefs[item.key] !== false;
          return (
            <li key={item.key} className="py-3 flex items-start justify-between gap-4">
              <div className="flex flex-col gap-0.5 min-w-0">
                <span className="text-sm font-medium text-text">{item.label}</span>
                <span className="text-xs text-text-2">{item.desc}</span>
              </div>
              <Toggle
                checked={checked}
                onCheckedChange={(v) => toggle(item.key, v)}
                aria-label={item.label}
                disabled={update.isPending}
              />
            </li>
          );
        })}
      </ul>
    </Card>
  );
}
